import React, { useReducer, createContext, useContext } from 'react';

import { ProviderProps } from 'commons/utils/types/provider';

import {
  initialState,
  BalanceState,
  Action,
  balanceReducer
} from './reducer/balance';

type BalanceContextType = {
  state: BalanceState;
  dispatch: React.Dispatch<Action>;
};

const BalanceContext = createContext<BalanceContextType | undefined>(undefined);

const useBalance = (): BalanceContextType => {
  const [state, dispatch] = useReducer(balanceReducer, initialState);

  return { state, dispatch };
};

const useBalanceContext = (): BalanceContextType => {
  const context = useContext(BalanceContext);

  if (!context) {
    throw new Error('useBalanceContext must be used within a BalanceProvider');
  }

  return context;
};

const BalanceProvider: React.FC<ProviderProps> = ({ children }) => {
  const balance = useBalance();
  return (
    <BalanceContext.Provider value={balance}>
      {children}
    </BalanceContext.Provider>
  );
};

export { useBalanceContext, BalanceProvider };
